import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import Fade from 'react-reveal/Fade';
import Button from '@material-ui/core/Button';
import ReactHtmlParser from 'react-html-parser';
import {withLocalize} from 'react-localize-redux';

class HomeSchool extends Component {
    render() {
        return (
            <section id="highlight-school" className="highlight-with-images">
                <div className="row">
                    <div className="col col-content col-12 col-md-4 offset-0 offset-md-1 align-self-center order-1 order-md-0 order-sm-1 order-1 mt-sm-50">
                        {this.props.widgets.bloc2_titre &&
                            <h3>{ReactHtmlParser(this.props.widgets.bloc2_titre.data.content)}</h3>
                        }
                        {this.props.widgets.bloc2_contenu &&
                            <div className="content">{ReactHtmlParser(this.props.widgets.bloc2_contenu.data.content)}</div>
                        }
                        {(this.props.widgets.bloc2_bouton && this.props.showButton) &&
                            <Button variant="contained" color="primary" className="btn-more" component={props => <Link to={this.props.translate('routes.schools')} {...props}/>}>
                                {this.props.widgets.bloc2_bouton.data.content}
                            </Button>
                        }
                    </div>
                    <div className="col col-images col-12 col-md-6 offset-md-1 order-0 order-md-1 order-sm-0 order-0">
                        <Fade top>
                            <div className="image image-1 back top right">
                                {this.props.widgets.bloc2_image1 &&
                                    <img src={this.props.widgets.bloc2_image1.data.url} alt=""/>
                                }
                            </div>
                        </Fade>
                        <Fade bottom>
                            <div className="image image-2 front bottom left">
                                {this.props.widgets.bloc2_image2 &&
                                    <img src={this.props.widgets.bloc2_image2.data.url} alt=""/>
                                }
                            </div>
                        </Fade>
                    </div>
                </div>
            </section>
        );
    }
}

HomeSchool.propTypes = {
    widgets: PropTypes.object.isRequired,
};

HomeSchool.defaultProps = {
    showButton: true,
};

export default withLocalize(HomeSchool);



// WEBPACK FOOTER //
// ./src/features/Home/components/HomeSchool.js